/*global location*/
import React from 'react'
import ReactDOM from 'react-dom'
import 'styles/style.css'
import Router from 'cerebral-module-router'
import { Controller } from 'cerebral'
import { Container } from 'cerebral-view-react'
import Model from 'cerebral/models/mutable'
import Devtools from 'cerebral-module-devtools'
import Login from 'modules/login/'
import Client from 'modules/client'
import User from 'modules/user'
import App from 'components/App/'
import AppModule from 'modules/app'
import Mail from 'modules/mail'
import Forms from 'cerebral-module-forms'
import Http from 'cerebral-module-http'
import {
  endsWith,
  hasExtensions,
  noWhitespace,
  notEqualTo,
  dateCompare,
  isFile,
  passwordRule
} from './formRules'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Useragent from 'cerebral-module-useragent'
import getURL from 'utils/url'
require('./customEventPolyFill')

Object.entries = function(obj) {
  const ownProps = Object.keys(obj)
  let i = ownProps.length
  let resArray = new Array(i) // preallocate the Array
  while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]]

  return resArray
}

const useragent = Useragent({
  media: {
    small: '(min-width: 600px)',
    medium: '(min-width: 1024px)',
    large: '(min-width: 1440px)',
    portrait: '(orientation: portrait)'
  },
  window: true
})

if(window.location.href.indexOf('account') === -1) window.location.href = getURL(window.location.pathname)

const baseUrl = '/account'
const controller = Controller(Model({}))

controller.addModules({
  app: AppModule(),
  useragent,
  client: Client(),
  login: Login(),
  user: User(),
  Http: Http({
    baseUrl,
    onResponse: function (xhr, resolve, reject) {
      let result = xhr.responseText

      if (xhr.getResponseHeader('content-type').indexOf('application/json') >= 0) {
        result = JSON.parse(xhr.responseText)
      }

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({
          status: xhr.status,
          result: result
        })
      } else if(xhr.status === 401) {
        window.location.reload()
      } else {
        reject({
          status: xhr.status,
          result: result
        })
      }
    }
  }),
  forms: Forms({
    rules: {
      notEqualTo,
      endsWith,
      hasExtensions,
      noWhitespace,
      dateCompare,
      isFile,
      passwordRule
    }
  }),
  mail: Mail(),
  devtools: process.env.NODE_ENV === 'production' ? function() {} : Devtools(),
  router: Router(
    {
      '/login': 'login.setLogin',
      '/welcome': 'user.onPrepareFields',
      '/users/add': 'user.prepareNewUser',
      '/user/edit/:_id': 'user.onPrepareFieldsForEditUser',
      '/users': {
        '': 'user.getUsers',
        '/unapproved': 'user.getUnapprovedUsers'
      },
      '/password/forgot': 'login.forgotPassword',
      '/password/restore/:token': 'login.restorePassword',
      '/registration/:currentPage': 'login.validateRegistrationStep',
      '/module/change/:name': 'user.changeModule',
      '/logout': 'user.logout',
      '/sso/error': 'login.failedThirdPartyLogin',
      '/': 'login.redirectToLogin',
      '*': 'login.noRoute',
    },
    {
      baseUrl,
      onlyHash: false,
      allowEscape: true
    }
  )
})

ReactDOM.render(
  <Container controller={controller}>
    <MuiThemeProvider muiTheme={getMuiTheme()}>
      <App />
    </MuiThemeProvider>
  </Container>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js